import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { useSettingsStore } from '@/store/modules/settings';
import { isExternal } from '@/utils/validate';
import { translate } from '@/i18n';
import { isHashRouterMode } from '@/config';

import { useRoute, useRouter } from 'vue-router';
import { inject } from 'vue';
import { storeToRefs } from 'pinia';
export default /*@__PURE__*/_defineComponent({
  __name: 'VabMenuItem',
  props: {
    itemOrMenu: {
      type: Object,
      default() {
        return null;
      }
    }
  },
  setup(__props, {
    expose: __expose
  }) {
    __expose();
    const props = __props;
    const route = useRoute();
    const router = useRouter();
    const $pub = inject('$pub');
    const settingsStore = useSettingsStore();
    const {
      device
    } = storeToRefs(settingsStore);
    const {
      foldSideBar
    } = settingsStore;
    const handleLink = () => {
      const routePath = props.itemOrMenu.path;
      const target = props.itemOrMenu.meta.target;
      if (target === '_blank') {
        if (isExternal(routePath)) window.open(routePath);else if (route.path !== routePath) isHashRouterMode ? window.open(`/#${routePath}`) : window.open(routePath);
      } else {
        if (isExternal(routePath)) window.location.href = routePath;else if (route.path !== routePath) {
          if (device.value === 'mobile') foldSideBar();
          router.push(props.itemOrMenu.path);
        } else $pub('reload-router-view');
      }
    };
    const __returned__ = {
      props,
      route,
      router,
      $pub,
      settingsStore,
      device,
      foldSideBar,
      handleLink,
      get translate() {
        return translate;
      }
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
});